import { Dropdown } from 'ccs-ui-components';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AUTH_METHOD } from '../../../../../constants';

interface IAuthMethodProps {
  authMethodChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  authMethodValue: string | undefined;
}
const AuthMethod = ({
  authMethodChangeHandler,
  authMethodValue
}: IAuthMethodProps) => {
  const { t: translate } = useTranslation();
  return (
    <Col md={6}>
      <Form.Group className="mb-3" controlId="authMethod">
        <Dropdown
          isMandatory
          labelText={String(translate('service_details_form_component.lbl_auth_method'))}
          label=""
          onChange={authMethodChangeHandler}
          data={AUTH_METHOD}
          placeholder={String(
            translate('service_details_form_component.txt_choose')
          )}
          value={authMethodValue}
          name="authMethod"
          data-testid="authMethod"
        />
      </Form.Group>
    </Col>
  );
};

export default AuthMethod;
